"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleJsonMapper = exports.ModuleDynamoMapper = void 0;
var module_dynamodb_1 = require("./module-dynamodb");
Object.defineProperty(exports, "ModuleDynamoMapper", { enumerable: true, get: function () { return module_dynamodb_1.ModuleDynamoMapper; } });
var module_json_1 = require("./module-json");
Object.defineProperty(exports, "ModuleJsonMapper", { enumerable: true, get: function () { return module_json_1.ModuleJsonMapper; } });
